import React from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/pages/auth/Login";

export default function PendingStatus() {
  return (
    <AuthShell title="Account pending" subtitle="Your team assignment request is awaiting approval.">
      <div className="rounded-xl border border-amber-200 bg-amber-50 p-6" data-testid="pending-status-card">
        <div className="flex items-start gap-4">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-amber-100 text-amber-600">
            <Clock className="h-5 w-5" />
          </span>
          <div>
            <p className="font-semibold text-slate-800">Waiting for approval</p>
            <p className="mt-1 text-sm text-slate-600">
              A coach or administrator must approve your assignment before you can log in.
              You'll be notified once a decision is made.
            </p>
          </div>
        </div>
      </div>
      <Button asChild className="mt-6 w-full rounded-full bg-slate-900 hover:bg-slate-800" data-testid="back-to-login-btn">
        <Link to="/login">Back to sign in</Link>
      </Button>
    </AuthShell>
  );
}
